export default "__VITE_ASSET__BayH41Ma__"